import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';

@Component({
  selector: 'Amarillas-create-currency',
  templateUrl: './create-currency.component.html',
  styleUrls: ['./create-currency.component.scss'],
})
export class CreateCurrencyComponent implements OnInit {
  @Input() edit: any;

  currencyForm: UntypedFormGroup;
  constructor(
    private fb: UntypedFormBuilder,
    public modalController: ModalController,
    private httpSv: HttpService,
    private uiSv: UiServices,
    private translateSv: TranslateService
  ) { }

  ngOnInit() {
    this.currencyForm = this.fb.group({
      name: ['', [Validators.required]],
      symbol: ['', [Validators.required, Validators.maxLength(5)]],
      change: ['', [Validators.required]],
      type: ['', [Validators.required]]
    })

    if(this.edit){
      this.currencyForm.patchValue(this.edit);
    }
  }

  async storeCurrency(){
    try{
      await this.uiSv.showLoading();
      let type = 'store';
      let txtType = this.translateSv.instant('CREADA');
      if(this.edit){
        type = 'update';
        txtType = this.translateSv.instant('EDITADA');
        this.currencyForm.value.id = this.edit.id;
      };
      await this.httpSv.itemAction(this.currencyForm.value, 'currency', type)
      await this.uiSv.loading.dismiss();
      await this.modalController.dismiss();
      const translateCoin = this.translateSv.instant('MONEDA');
      const translateExt = this.translateSv.instant('CON_EXITO');
      await this.uiSv.showToast(`${translateCoin} ${txtType} ${translateExt}`);
    }catch(err){
      await this.uiSv.loading.dismiss();
      const translate = this.translateSv.instant('HA_OCURRIDO_UN_ERROR');
      await this.uiSv.showToast(translate)
    }
  }

}
